import { get, groupBy } from 'lodash';
import { useEffect, useState } from 'react';
import { SeatDetailProps } from '../api/response';
import EchoSocket from '../utils/Socket';
import { useSocketViewSeatQuery } from './socket/useSocketViewSeatQuery';
import { useUserInfoState } from './states/useUserInfoState';

interface SocketProps {
  itemId: string;
  userId: string;
}

export const useSeatSelectionListener = ({ seatDetail }: { seatDetail?: SeatDetailProps }) => {
  const [busySeatObj, setBusySeatObj] = useState<any>();
  const { userInfo } = useUserInfoState();
  const { data: selectedSeatViewData, refetch: selectedSeatRefetch } = useSocketViewSeatQuery({
    seatChannel: seatDetail?.seatChannel,
  });

  useEffect(() => {
    if (seatDetail) selectedSeatRefetch();
  }, [seatDetail]);

  useEffect(() => {
    let unsubscription: any;
    if (selectedSeatViewData) {
      console.log({ selectedSeatViewData });
      const busySeats = groupBy(selectedSeatViewData, 'itemId');
      setBusySeatObj(busySeats);

      unsubscription = EchoSocket.seatSelection({
        channel: seatDetail?.seatChannel || '',
        onSelected: (dataEcho: SocketProps) => {
          if (dataEcho.userId === userInfo?.id) {
            // ខ្លួនឯង
            return;
          }
          if (get(busySeats, `[${dataEcho.itemId}]`)) {
            setBusySeatObj((prev: any) => {
              const foundObject = {
                ...prev[dataEcho.itemId][0],
                viewCounter: prev[dataEcho.itemId][0].viewCounter + 1,
              };
              return { ...prev, [dataEcho.itemId]: [foundObject] };
            });
          } else {
            setBusySeatObj((prev: any) => {
              return { ...prev, [dataEcho.itemId]: [{ viewCounter: 1 }] };
            });
          }
        },
        onUnselected: (dataEcho: SocketProps) => {
          if (dataEcho.userId === userInfo?.id) {
            // ខ្លួនឯង
            return;
          }
          setBusySeatObj((prev: any) => {
            let temp = prev;
            for (let i = 0; i < dataEcho.itemId.length; i += 1) {
              const foundObject = {
                ...temp[dataEcho.itemId[i]][0],
                viewCounter: temp[dataEcho.itemId[i]][0].viewCounter - 1,
              };
              temp = { ...temp, [dataEcho.itemId[i]]: [foundObject] };
            }

            return temp;
          });
        },
      });
    }
    return () => {
      if (unsubscription) unsubscription();
    };
  }, [selectedSeatViewData]);

  return busySeatObj;
};
